import PropTypes from 'prop-types';

import { tagShape } from '../../../shared/types';
import taskStatusShape from './taskStatus';

const caseFileShape = PropTypes.shape({
  name: PropTypes.string.isRequired,
});

const personShape = PropTypes.shape({
  avatarColor: PropTypes.string.isRequired,
  fullName: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  initials: PropTypes.string.isRequired,
});

const taskShape = PropTypes.shape({
  createdAt: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  priority: PropTypes.oneOf(['urgent', 'high', 'medium', 'low', null]).isRequired,
  tags: PropTypes.arrayOf(tagShape).isRequired,
  assignee: personShape,
  caseFile: caseFileShape,
  taskStatus: taskStatusShape,
});

export default taskShape;
